'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobCompanies } from '../../Entities/Glob/GlobCompanies';
import { GlobCompaniesCollection } from '../../Collections/Glob/GlobCompaniesCollection';

export class GlobCompaniesRepository extends CoreRepository {
  public getGlobCompanies(options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getGlobCompanies(options).then((response) => {
      const collection = new GlobCompaniesCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobCompanies();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
